import Vue from 'vue';
import Router from 'vue-router';

// It is possible to load pages async in the following manner: (It is not used due to the minimal performance benefit (most pages are <10kb))
//const Home = () => import('@/components/pages/Home');

import Home from '@/components/pages/Home';
import Pakbonnen from '@/components/pages/Pakbonnen';
import Pakbon from '@/components/pages/Pakbon';
import LOrders from '@/components/pages/LopendeOrders';
import LOrder from '@/components/pages/LopendeOrder';
import Facturen from '@/components/pages/Facturen';
import Factuur from '@/components/pages/Factuur';
import CNotas from '@/components/pages/Creditnotas';
import CNota from '@/components/pages/Creditnota';
import Licenties from '@/components/pages/Licenties';
import OpenPosten from '@/components/pages/OpenPosten';
import Minas from '@/components/pages/reports/Minas';
import SalesRep from '@/components/pages/reports/Sales';
import ActiveSub from '@/components/pages/reports/ActiveSubstances';

Vue.use(Router);

var myRouter = new Router({
  routes: [
    { path: '/', name: 'Start', component: Home },

    { path: '/Pakbonnen', name: 'Pakbonnen', component: Pakbonnen },
    { path: '/Pakbon/:id', name: 'Pakbon', component: Pakbon, props: true },

    { path: '/LopendeOrders', name: 'Lopende orders', component: LOrders },
    { path: '/LopendeOrder/:id', name: 'Order', component: LOrder, props: true },

    { path: '/Facturen', name: 'Facturen', component: Facturen },
    { path: '/Factuur/:id', name: 'Factuur', component: Factuur, props: true },

    { path: '/Creditnotas', name: 'Creditnota\'s', component: CNotas },
    { path: '/Creditnota/:id', name: 'Creditnota', component: CNota, props: true },

    { path: '/Licenties', name: 'Licentie overzicht', component: Licenties },

    { path: '/OpenPosten', name: 'Open posten', component: OpenPosten },

    { path: '/Minas', name: 'Minas', component: Minas },
    { path: '/Afname', name: 'Afname per productgroep', component: SalesRep },
    { path: '/WerkzameStoffen', name: 'Werkzame stoffenlijst', component: ActiveSub }
  ]
});

myRouter.beforeEach((to, from, next) => {
  console.log(`Routing from '${from.fullPath}' to '${to.fullPath}'.`);
  document.title = `${Vue.prototype.$portalName} - ${to.name}`;
  next();
});

export default myRouter;



// WEBPACK FOOTER //
// ./src/router/index.js